import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import CampOperatorCreateEditForm from './Components/CampOperatorCreateEditForm';
import CampOperatorApi from './CampOperatorApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: CampOperatorCreateEditForm,
                getCreate: CampOperatorApi.create,
                defaults: {},
                successMessage: "Camp Operator Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}